import { create } from 'zustand';
import type { AudioTrack, AudioSelection, AudioTrackFilters } from '../types/audio';

interface AudioState {
  audioTracks: AudioTrack[];
  currentAudioSelection: AudioSelection | null;
  isLoading: boolean;
  error: string | null;
  filters: AudioTrackFilters;

  setAudioTracks: (tracks: AudioTrack[]) => void;
  setCurrentAudioSelection: (selection: AudioSelection | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setFilters: (filters: AudioTrackFilters) => void;
  addAudioTrack: (track: AudioTrack) => void;
  updateAudioTrack: (id: string, updates: Partial<AudioTrack>) => void;
  removeAudioTrack: (id: string) => void;
  reset: () => void;
}

export const useAudioStore = create<AudioState>((set) => ({
  audioTracks: [],
  currentAudioSelection: null,
  isLoading: false,
  error: null,
  filters: {},

  setAudioTracks: (tracks) => set({ audioTracks: tracks }),
  setCurrentAudioSelection: (selection) => set({ currentAudioSelection: selection }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  setFilters: (filters) => set({ filters }),
  addAudioTrack: (track) => set((state) => ({ audioTracks: [...state.audioTracks, track] })),
  updateAudioTrack: (id, updates) =>
    set((state) => ({
      audioTracks: state.audioTracks.map((track) =>
        track.id === id ? { ...track, ...updates } : track
      ),
    })),
  removeAudioTrack: (id) =>
    set((state) => ({
      audioTracks: state.audioTracks.filter((track) => track.id !== id),
    })),
  reset: () =>
    set({
      audioTracks: [],
      currentAudioSelection: null,
      isLoading: false,
      error: null,
      filters: {},
    }),
}));
